<div class="not-found-container">
    <h1>404</h1>
    <p class="message">Oops! The page you're looking for doesn't exist.</p>
    <button routerLink="/" class="back-home-btn">Go to Home</button>
  </div>
  